import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex gap-4 flex-wrap" };
import { computed, ref } from 'vue';
import ToggleButton from 'primevue/togglebutton';
export default /*#__PURE__*/ _defineComponent({
    __name: 'OfficeSelection',
    props: {
        selectedOffices: {},
        allowedOffices: {}
    },
    emits: ["update:office-selection"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const availableOffices = computed(() => props.allowedOffices.split(','));
        const selectedOffices = computed(() => props.selectedOffices.split(','));
        const isSelected = (name) => selectedOffices.value.findIndex(office => office === name) !== -1;
        const buildModel = () => availableOffices.value.map(office => ({ name: office, selected: isSelected(office) }));
        const selectedModel = ref(buildModel());
        const onSelectionChange = () => {
            const selected = selectedModel.value.filter(office => office.selected);
            let selection = '';
            if (selected?.length) {
                selection = selected.map(x => x.name).join(',');
            }
            emit('update:office-selection', selection);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedModel.value, (selected, idx) => {
                    return (_openBlock(), _createBlock(_unref(ToggleButton), {
                        key: idx,
                        modelValue: selectedModel.value[idx].selected,
                        "onUpdate:modelValue": [($event) => ((selectedModel.value[idx].selected) = $event), onSelectionChange],
                        "on-label": selected.name,
                        "off-label": selected.name,
                        "off-icon": "pi pi-times-circle",
                        "on-icon": "pi pi-check-circle"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "on-label", "off-label"]));
                }), 128))
            ]));
        };
    }
});
